module.exports = __webpack_public_path__ + "img/search.2f157c99.png";